export const sr = {
  accept: 'U redu',
  reject: 'Otkaži',
  dayNames: [
    'Nedelja',
    'Ponedeljak',
    'Utorak',
    'Sreda',
    'Četvrtak',
    'Petak',
    'Subota',
  ],
  dayNamesShort: ['Ned', 'Pon', 'Uto', 'Sre', 'Čet', 'Pet', 'Sub'],
  monthNames: [
    'Januar',
    'Februar',
    'Mart',
    'April',
    'Maj',
    'Jun',
    'Jul',
    'Avgust',
    'Septembar',
    'Oktobar',
    'Novembar',
    'Decembar',
  ],
  monthNamesShort: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'Maj',
    'Jun',
    'Jul',
    'Avg',
    'Sep',
    'Okt',
    'Nov',
    'Dec',
  ],
  today: 'Danas',
  clear: 'Obriši',
  dateFormat: 'dd.mm.yy',
  firstDayOfWeek: 1,
  emptyMessage: 'Nema podataka',

  // 🌐 MultiSelect / Dropdown
  choose: 'Izaberi',
  filter: 'Filtriraj',
  close: 'Zatvori',
  apply: 'Primeni',
  selectAll: 'Izaberi sve',
  unselectAll: 'Poništi izbor',
  emptyFilterMessage: 'Nema rezultata',
  emptySelectionMessage: 'Ništa nije izabrano',
  selectedItemsLabel: '{0} stavke izabrane',
  maxSelectedLabels: '{0} stavke izabrane',
  chipSelected: '{0} izabrano',

  first: 'Prva',
  last: 'Poslednja',
  next: 'Sledeća',
  previous: 'Prethodna',
  rowsPerPage: 'Redova po stranici',
  currentPageReport: '{first}–{last} od {totalRecords}',
};
